const ENTRY_NOT_FOUND = 'BACKEND_SERVER.CONTROLLER.DEVELOPMENT_ORDER.ORDER_SUBMIT_DOWNLOAD.ENTRY_NOT_FOUND';
const MODULE_ENTRY_MISSING = 'DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.MODULE_ENTRY_MISSING';
const DOWNLOAD_FAILED = 'DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLODS_PRODUCT.DOWNLOAD_FAILED';
const TRANSLATION_KEY = /^[A-Z][A-Z0-9_]*(\.[A-Z][A-Z0-9_]*)+$/;

export interface SubmitDownloadFailureNotice {
  reason?: string;
  missingModules?: string[];
}

export interface SubmitDownloadFailureMessage {
  key: string;
  options?: { modules: string };
}

/**
 * Picks the message for a failed submit-download: the empty modules when the product has no entry
 * for them, the server's reason when it named a translation key, otherwise the generic failure.
 * @param notice - the failure the server reported.
 * @returns the translation key to show, with its interpolation values.
 */
export function submitDownloadFailureMessage(notice: SubmitDownloadFailureNotice): SubmitDownloadFailureMessage {
  const modules = notice.missingModules ?? [];
  if (notice.reason === ENTRY_NOT_FOUND && modules.length > 0) {
    return { key: MODULE_ENTRY_MISSING, options: { modules: modules.join(', ') } };
  }
  if (notice.reason && TRANSLATION_KEY.test(notice.reason)) {
    return { key: notice.reason };
  }
  return { key: DOWNLOAD_FAILED };
}
